export type UserRole = 'ROLE_ADMIN' | 'ROLE_GUEST' | 'ROLE_MANAGER';
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserRole = {
  ROLE_ADMIN: 'ROLE_ADMIN' as UserRole,
  ROLE_GUEST: 'ROLE_GUEST' as UserRole,
  ROLE_MANAGER: 'ROLE_MANAGER' as UserRole,
};
